/* eslint prefer-template:0 */

export default function getQueryUtils(window) {
    /**
     * Get value of URL parameter by its name
     * @param {string} name
     * @param {string} query
     * @returns {string}
     */
  function getParameterFromQuery(query, name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
    const results = regex.exec(query)
    return results && results[1] ? decodeURIComponent(results[1]).replace(/\+/g, ' ') : ''
  }

    /**
     * Get state of boolean URL parameter by its name
     * @param {string} name
     * @param {string} query
     * @returns {boolean}
     */
  function isParameterTrueInQuery(query, name) {
    return getParameterFromQuery(query, name) === 'true'
  }

  return {
    getParameterFromQuery,
    isParameterTrueInQuery,
    getParameterByName: getParameterFromQuery.bind(null, window.location.search),
    isParameterTrue: isParameterTrueInQuery.bind(null, window.location.search)
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/getQueryUtils.js